import { isDemoMode } from '../config/env';
import { api } from './api';
import { demoAnnouncements } from '../demo/demoApi';
import type { Announcement, CreateAnnouncementPayload } from '../types/announcements';

export const ANNOUNCEMENTS_CHANGED_EVENT = 'dancemance:announcements-changed';

function notifyAnnouncementsChanged() {
  window.dispatchEvent(new Event(ANNOUNCEMENTS_CHANGED_EVENT));
}

export const announcementService = {
  listMine: async () =>
    isDemoMode ? demoAnnouncements.listMine() : api.get<Announcement[]>('/announcements/me'),

  list: async () =>
    isDemoMode ? demoAnnouncements.list() : api.get<Announcement[]>('/announcements'),

  create: async (payload: CreateAnnouncementPayload) => {
    const row = isDemoMode
      ? demoAnnouncements.create(payload)
      : await api.post<Announcement>('/announcements', payload);
    notifyAnnouncementsChanged();
    return row;
  },

  deactivate: async (id: string) => {
    const row = isDemoMode
      ? demoAnnouncements.deactivate(id)
      : await api.patch<Announcement>(`/announcements/${id}`, { active: false });
    notifyAnnouncementsChanged();
    return row;
  },

  getAuthBanner: async () =>
    isDemoMode ? demoAnnouncements.getAuthBanner() : api.get<Announcement | null>('/announcements/auth'),
};
